<div class="table-section">
    <app-submitted-forms-list></app-submitted-forms-list>
</div>